/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Score_Legend_Rtp_LinkInputs */



/**
* | output |
* | --- |
* | "See rankings" |
*
* @param {Score_Legend_Rtp_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const score_legend_rtp_link = /** @type {((inputs?: Score_Legend_Rtp_LinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Score_Legend_Rtp_LinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir les classements")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver clasificaciones")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ver classificações")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vedi classifiche")
	return /** @type {LocalizedString} */ ("See rankings")
});